export default "__VITE_ASSET__DJAhvUOB__"